import React from 'react';
import BankAccountAuthentication from '@/pages/BankAccountAuthentication';
import './BankDetailsWrapper.css';

interface BankDetailsWrapperProps {
  value?: any;
  onChange?: (data: any) => void;
  onDone?: () => void;
  registerSubmit?: (handler: () => Promise<boolean>) => void;
  isBuilderMode?: boolean;
}

/**
 * Wrapper component for Bank Account Authentication page
 * Used in journey builder to integrate the existing BankAccountAuthentication page
 * 
 * This wrapper:
 * - Wraps the existing BankAccountAuthentication.tsx page
 * - Hides unnecessary UI layers (like duplicate headers)
 * - Integrates with the journey builder's component system
 * - Provides a clean interface for the journey flow
 * 
 * Similar to DigioMandateSetup wrapper pattern
 * 
 * Note: Uses CSS to hide unnecessary layers from BankAccountAuthentication page
 */
const BankDetailsWrapper: React.FC<BankDetailsWrapperProps> = ({
  value,
  onChange,
  onDone,
  registerSubmit,
  isBuilderMode = false,
}) => {
  // Pass registerSubmit and onDone directly to BankAccountAuthentication
  // It will handle the submit logic internally.
  // onChange is forwarded so the page can report its 4 mandatory fields up to
  // JourneyPage, which greys out Continue until they are complete.

  return (
    <div className="bank-details-wrapper">
      <BankAccountAuthentication
        isBuilderMode={isBuilderMode}
        registerSubmit={registerSubmit}
        onDone={onDone}
        onChange={onChange}
      />
    </div>
  );
};

export default BankDetailsWrapper;
